import React, { useEffect, useState } from "react";
import FadeIn from "react-fade-in/lib/FadeIn";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Table,
} from "reactstrap";
import Breadcrumb from "../../../../components/Common/Breadcrumb";
import SubMenuEntryWork from "../../SubMenuEntryWork";
import { GetCookieData, GetCookieToken } from "../../../Cookie/GetCookie";
import axios from "axios";
import { ConvertDate } from "../../../Function/ConvertDate";

import MyThaiDatePick from "../../../../components/Common/ThaiDatePicker";
import NewThaiDatePicker from "../../../../components/Common/NewThaiDatePicker";

const Menu4 = ({ menu }) => {
  const baseURL = process.env.REACT_APP_API_CORS;
  const token = GetCookieToken("userToken");
  const user = GetCookieData("userData");
  const user_id = user?.user_id;

  const [data, setData] = useState([]);
  const [dataPagination, setDataPagination] = useState(10);
  const [dataPaginationFrist, setDataPaginationFrist] = useState(0);
  const [entryData, setEntryData] = useState([]);
  const [exitData, setExitData] = useState([]);
  const [filterSearch, setFilterSearch] = useState({
    startDate: null,
    toDate: null,
  });
  const [validateFilter, setValidateFilter] = useState({
    startDate: true,
    toDate: true,
  });
  const [textValidateFilter, setTextValidateFilter] = useState({
    startDate: null,
    toDate: null,
  });

  const [dataInColorBoxes, setDataInColorBoxes] = useState([
    { color: "primary", text: "เต็มวัน", data: 0 }, //dataInColorBoxes[0].data
    { color: "success", text: "ไม่เต็มเวลา", data: 0 },
    { color: "warning", text: "ขาด", data: 0 },
    { color: "danger", text: "สาย", data: 0 }
  ])

  const [isLoading, setIsLoading] = useState(false)

  const getDataTable = async () => {
    setIsLoading(true)
    const url = baseURL + "/api/time/history";
    const params = new URLSearchParams({
      page: 1,
      size: 100000,
      "order[0]": "scan_date",
      "order[1]": "ASC",
      "filter[user_id][0]": user_id,
      "filter[entry_exit_status][0]": "0",
      "filter[entry_exit_status][1]": "1",
      "filter[entry_exit_status][2]": "2",
      "filter[entry_exit_status][3]": "4",
      "filter[entry_exit_status][4]": "5",
      date_start: ConvertDate(filterSearch?.startDate)?.toOnlyDate(),
      date_end: ConvertDate(filterSearch?.toDate)?.toOnlyDate(),
    });
    const config = {
      headers: {
        Authorization: `Beare ${token}`,
      },
      params,
    };
    try {
      await setData([]);
      const res = await axios.get(url, config);
      let result = res?.data?.result
      setData(result);

      let fullTimeCount = 0;
      let absentCount = 0;
      let halfTimeCount = 0;
      let lateCount = 0;
      result.map((element, index, array) => {
        if (element.entry_exit_status === 4) {
          absentCount++
        } else if (element.late === 1) {
          lateCount++
        } else if (element.status === "ไม่เต็มเวลา") {
          halfTimeCount++
        } else if (element.entry_exit_status === 1 && index > 0 && array[index - 1].entry_exit_status === 0) {
          const differenceInHours = Math.abs(new Date(element.scan_date) - new Date(array[index - 1].scan_date)) / (1000 * 60 * 60)
          if (differenceInHours >= 8) {
            fullTimeCount ++
          }
        } else if (element.note === "ไม่เต็มเวลา") {
          halfTimeCount ++
        }
        return null;
      });
      
      setDataInColorBoxes(prev =>
        prev.map(item =>
          item.text === "เต็มวัน"
            ? { ...item, data: fullTimeCount }
            : item.text === "ไม่เต็มเวลา"
              ? { ...item, data: halfTimeCount }
              : item.text === "ขาด"
                ? { ...item, data: absentCount }
                : item.text === "สาย"
                  ? { ...item, data: lateCount }
                  : item
        )
      );
      setIsLoading(false)
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (data && data?.length !== 0) {
      data?.map((item) => {
        if (item?.entry_exit_status !== 1) {
          // setEntryData((prev) => [...prev, item]);
          setEntryData((prev) => {
            const newData = new Set([...prev, item]);
            return [...newData];
          });
        } else {
          // setExitData((prev) => [...prev, item]);
          setExitData((prev) => {
            const newData = new Set([...prev, item]);
            return [...newData];
          });
        }
      });
    }
  }, [data,dataPagination]);

  const handleSubmit = async () => {
    setData([]);
    setEntryData([]);
    setExitData([]);
    setDataPaginationFrist(0);
    setDataPagination(10);
    await getDataTable();
    await toggleData();
  };

  const [toggleCard, setToggleCard] = useState(false);
  const toggleData = async () => {
    setToggleCard(true);
  };

  const CheckValidate = () => {
    if(validateFilter?.startDate && validateFilter?.toDate) {
      setTextValidateFilter(prev => ({...prev, startDate: true, toDate: true}))
    }
  }

  const setStartDate = (e) => {
    setFilterSearch((prev) => ({
      ...prev,
      startDate: e,
      toDate: e,
    }));
    setValidateFilter(prev => ({...prev, startDate: false}))
    setTextValidateFilter(prev => ({...prev, startDate: false}))
  }

  const setToDate = (e) => {
    setFilterSearch((prev) => ({
      ...prev,
      toDate: e,
    }));
    setValidateFilter(prev => ({...prev, toDate: false}))
    setTextValidateFilter(prev => ({...prev, toDate: false}))
  }

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <FadeIn>
      <SubMenuEntryWork menu={3} />

      <Breadcrumb
        title="หน้าหลัก"
        breadcrumbItem="ลงเวลาปฏิบัติราชการ"
        isBack={true}
        isSubMenu={true}
        subMenuName="ค้นหาข้อมูล"
        // subMenuName="จัดการข้อมูลพนักงาน"
        path="/entrywork"
      />
          {/* {toggleCard && ( */}
    <Row className="d-flex justify-content-center">
        <Col xxl={9}>
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      if (
                        !validateFilter?.startDate &&
                        !validateFilter?.toDate
                      ) {
                        handleSubmit();
                      } else {
                        CheckValidate()
                      }
                    }}
                  >
                    <FormGroup row className="d-flex justify-content-center">
                      <Label className="text-center" xxl={2}>
                        ตั้งแต่วันที่
                      </Label>
                      <Col xxl={2}>
                        <NewThaiDatePicker name = {"dmy_start"} value={filterSearch?.startDate} setValue={setStartDate} returnType = {"DateTime"} placeholderText = "วัน/เดือน/ปี"/>
                        {textValidateFilter?.startDate && (
                          <p className="text-danger">กรุณาระบุวันที่</p>
                        )}
                      </Col>
                      <Label className="text-center" xxl={2}>
                        ถึงวันที่
                      </Label>
                      <Col xxl={2}>
                        <NewThaiDatePicker name = {"dmy_end"} value={filterSearch?.toDate} minDate={filterSearch?.startDate} setValue={setToDate} returnType = {"DateTime"} placeholderText = "วัน/เดือน/ปี"/>
                        {textValidateFilter?.toDate && (
                          <p className="text-danger">กรุณาระบุวันที่</p>
                        )}
                      </Col>
                      <Col xxl={1} xs={12} className="d-flex justify-content-center mt-2 mt-xxl-0">
                        <Button color="primary" type="submit">
                          ค้นหา
                        </Button>
                      </Col>
                    </FormGroup>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
            <FadeIn>
              <Row>
                <Col>
                  <Card>
                    <CardBody>
                      
                    <Row className="mb-3">
                      <Col>
                        <Row className="d-flex justify-content-between" >
                          {dataInColorBoxes.map((item, index) => (
                            <Col key={index} md={3} lg={3} xl={3} xxl={3} className="mb-2" 
                              style={{height:windowSize.width < 576 
                                || (windowSize.width >= 576 && windowSize.width < 992 ) 
                                || (windowSize.width >= 992 && windowSize.width < 1200 )
                                  ? "" 
                                  : "200px"}}
                            >
                              <div className={`bg-${item.color} w-100 h-100 rounded-5 d-flex align-items-center justify-content-center`}>
                                <Row>
                                  <h2 className="d-flex justify-content-center text-light"><b>{item.text}</b></h2>
                                  <h2 className="d-flex justify-content-center text-light"><b>{item.data}</b></h2>
                                </Row>
                              </div>
                            </Col>
                          ))}
                        </Row>
                      </Col>
                    </Row>

                      <Row>
                        <Col>
                          <Table responsive>
                            <thead className="table- fs-5">
                              <tr>
                                <th className="text-center" width="17%">
                                  วันที่
                                </th>
                                <th className="text-center" width="17%">
                                  เข้างาน
                                </th>
                                <th className="text-center" width="17%">
                                  ออกงาน
                                </th>
                                <th className="text-center" width="17%">
                                  สถานะ
                                </th>
                                <th className="text-center">หมายเหตุ</th>
                              </tr>
                            </thead>
                            <tbody>
                              {entryData.length === 0 ? 
                              <tr><td colSpan={5} className="text-center fs-5">ไม่มีข้อมูล</td></tr>
                              : entryData?.map((item, idx) => {
                                
                                  let startDateEntry = new Date(
                                    item?.date
                                  )?.toLocaleDateString();
                                  let result = [];
                                  result = exitData?.filter((prev) => {
                                    if (
                                      new Date(
                                        prev?.date
                                      )?.toLocaleDateString() === startDateEntry
                                    ) {
                                      return prev?.date;
                                    }
                                  });
                                  let timeEntry =
                                    item?.scan_date
                                      ?.split("T")[1]
                                      ?.split(".")[0] !== "00:00:00"
                                      ? item?.scan_date
                                          ?.split("T")[1]
                                          ?.split(".")[0]
                                      : "-";
                                  let timeExit =
                                    result?.length !== 0
                                      ? result[0]?.scan_date
                                          ?.split("T")[1]
                                          ?.split(".")[0]
                                      : "-";
                                  let status =
                                    result?.length !== 0
                                      ? result[0]?.note
                                      : null;
                                  if ((idx + 1) <= dataPagination && (idx + 1) > dataPaginationFrist) {
                                      return (
                                      <tr key={idx} className="fs-5">
                                        <td className="text-center">
                                          {result?.length !== 0
                                            ? ConvertDate(
                                                result[0]?.date
                                              )?.toThaiDateDMY()
                                            : ConvertDate(
                                                item?.date
                                              )?.toThaiDateDMY()}
                                        </td>
                                        <td className="text-center">
                                          {timeEntry}
                                        </td>
                                        <td className="text-center">
                                          {timeExit}
                                        </td>
                                        <td className="text-center">{status || "-"}</td>
                                        <td className="">{item.late === 1 ? "สาย" : item?.entry_exit_status === 5 || item?.entry_exit_status === 2 ? item?.note : item?.entry_exit_status === 4 ? item?.entry_exit_status_name : null}</td>
                                      </tr>
                                    );
                                  } 
                                  
                                })}
                            </tbody>
                          </Table>
                        </Col>
                      </Row>
                     
                    </CardBody>
                  </Card>
                  <Row
                        className="mx-2"
                        style={{
                          display: "flex",
                          alignItems: "end",
                        }}
                      >
                        <Col xxl={4} className="mb-2">
                          <h4>
                            <Badge className="badge-soft-primary me-1 fs-5">
                              ทั้งหมด {Math.ceil(entryData?.length / 10)} รายการ
                            </Badge>
                          </h4>
                        </Col>
                        <Col xxl={8} className="d-flex justify-content-end">
                          <Pagination>
                            <PaginationItem disabled={((dataPagination / 10) === 1) || entryData?.length === 0}>
                              <PaginationLink 
                                onClick={() => {
                                  setDataPaginationFrist(0)
                                  setDataPagination(10)
                                }}
                                >
                                หน้าแรก
                              </PaginationLink>
                            </PaginationItem>
                            <PaginationItem disabled={((dataPagination / 10) === 1) || entryData?.length === 0}>
                              <PaginationLink
                                onClick={() => {
                                  setDataPaginationFrist(dataPagination - 20)
                                  setDataPagination(dataPagination - 10)
                                }}
                              >
                                ย้อนกลับ
                              </PaginationLink>
                            </PaginationItem>
                            <PaginationItem active>
                              <PaginationLink>
                                หน้า {Math.ceil(dataPagination / 10)} จาก {entryData?.length > 0 ? Math.ceil(entryData?.length / 10) : "1" }
                              </PaginationLink>
                            </PaginationItem>
                            <PaginationItem 
                              disabled={((dataPagination / 10) === Math.ceil(entryData?.length / 10)) || entryData?.length === 0}
                            >
                              <PaginationLink
                                onClick={() => {
                                  setDataPaginationFrist(dataPagination)
                                  setDataPagination(10 + dataPagination)
                                }}
                              >
                                ถัดไป
                              </PaginationLink>
                            </PaginationItem>
                            <PaginationItem disabled={((dataPagination / 10) === Math.ceil(entryData?.length / 10)) || entryData?.length === 0}>
                              <PaginationLink
                                onClick={() => {
          
                                  setDataPaginationFrist((Math.ceil(entryData?.length / 10) * 10) - 10)
                                  setDataPagination(Math.ceil(entryData?.length / 10) * 10)
                                }}
                              >
                                หน้าสุดท้าย
                              </PaginationLink>
                            </PaginationItem>
                          </Pagination>
                        </Col>
                    </Row>
                </Col>
              </Row>
            </FadeIn>
           {/* )} */}
        </Col>
      </Row>
    </FadeIn>
  );
};

export default Menu4;
